@if (!navigationItemVisibilityService.isNavigationItemHidden(navigationItem)) {
  <li
    [ngClass]="{
      'selected-item':
        isSelected() &&
        !navigationItemVisibilityService.isContainingVisibleChildren(navigationItem),
      '-open': navigationItem.isOpenGroup,
    }"
    class="m-side-navigation__menuItem -open"
    role="none"
  >
    <a
      (click)="navigationItemClickService.clickNavigationItem(navigationItem)"
      [ngClass]="{ 'cannot-drop': dragDropService.widgetIsDragging$ | async }"
      class="m-side-navigation__link"
      role="menuitem"
      [attr.data-user-guide-target]="navigationItem.userGuideTargetId ?? null"
    >
      <i
        [ngClass]="navigationItem.icon"
        [title]="
          navigationItem.nameKey ? (navigationItem.nameKey | translate) : navigationItem.name
        "
        class="a-icon"
      ></i>
      <span class="m-side-navigation__label transition-opacity duration-150 ease-out">
        {{ navigationItem.nameKey ? (navigationItem.nameKey | translate) : name }}
      </span>
      @if (navigationItemVisibilityService.isContainingVisibleChildren(navigationItem)) {
        <i
          [ngClass]="{
            'boschicon-bosch-ic-up': navigationItem.isOpenGroup,
            'boschicon-bosch-ic-down': !navigationItem.isOpenGroup,
          }"
          class="a-icon arrow boschicon-bosch-ic-down"
          title="up-down-buttons"
        ></i>
      }
    </a>
    @if (navigationItem.isOpenGroup) {
      <ul class="m-side-navigation__menuSubitems" role="menu">
        @for (sideNavActionItem of navigationItem.children; track sideNavActionItem) {
          <side-navigation-action-item
            [childNavigationItem]="sideNavActionItem"
          ></side-navigation-action-item>
        }
      </ul>
    }
  </li>
}
